import React, { FunctionComponent } from 'react';

import { LogoList as LogoListType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';
import BlockRenderer from './BlockRenderer';

export const LogoListFragment = graphql`
  fragment LogoListFragment on SanityLogoList {
    rawTitle: _rawTitle
    variant {
      variant
    }
    logos {
      alt
      asset {
        localFile {
          childImageSharp {
            gatsbyImageData(width: 512, placeholder: BLURRED, formats: [PNG, WEBP])
          }
        }
      }
    }
    ctas {
      ...CtaFragment
    }
  }
`;

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    root: {
      boxSizing: 'border-box',
      textAlign: 'center',
    },
    logoContainer: {
      boxSizing: 'border-box',
    },
    logo: {
      width: spacing(25),
      margin: spacing(1, 2),
    },
  } as const;
};

const LogoList: FunctionComponent<LogoListType> = (props) => {
  const { rawTitle, ctas = [], logos } = props;
  const classes = useStyles();

  return (
    <BreakpointContainer padding={{ xs: [8, 0], md: [8, 4] }} width="100%" maxWidth="xl">
      <Flex flexDirection="column" width="100%" css={classes.root} padding={[0, 4]}>
        {rawTitle && <BlockRenderer blocks={rawTitle} />}
        <BreakpointContainer
          padding={[4, 2, 0]}
          flexDirection="row"
          maxWidth="xl"
          justifyContent="center"
          flexWrap="wrap"
          css={{ boxSizing: 'border-box' }}
        >
          {logos?.map(({ alt = '', asset }, i) => {
            if (!asset?.localFile?.childImageSharp?.gatsbyImageData) {
              return null;
            }
            return (
              <GatsbyImage
                alt={alt}
                image={asset?.localFile?.childImageSharp?.gatsbyImageData}
                key={i}
                css={classes.logo}
                imgStyle={{ objectFit: 'contain' }}
              />
            );
          })}
        </BreakpointContainer>
        {ctas.length > 0 && (
          <Flex width="100%" justifyContent="center" margin={[0, 0, 4]}>
            <Buttons ctas={ctas} />
          </Flex>
        )}
      </Flex>
    </BreakpointContainer>
  );
};

export default LogoList;
